export default "__VITE_ASSET__9Inzwi2Q__"